/* Ever Ready: sterren en reviewaantal op productkaarten (bron: ev-reviews.json of metafield custom.ev_reviews).
   Stond eerst inline in snippets/product-card.liquid en werd per kaart herhaald. */
(function() {
  if (window._evCardRatingDone) return;
  window._evCardRatingDone = true;

  var s = document.createElement('style');
  s.textContent =
    '.ev-price-extra{font-size:12px;line-height:1.3;color:#555;margin:2px 0 0;}' +
    '.product-single__box__block--price .ev-price-extra{font-size:13px;margin:4px 0 0;}';
  document.head.appendChild(s);

  var SCRIPT = document.currentScript;
  var URL = SCRIPT && SCRIPT.dataset.reviewsUrl;
  if (!URL) return;
  var FULL  = '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/></svg>';
  var HALF  = '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 2L8.91 8.26 2 9.27 7 14.14 5.82 21.02 12 17.77Z" fill="currentColor"/></svg>';
  var EMPTY = '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.ev-card-rating{display:flex;align-items:center;gap:4px;font-size:13px;line-height:1;margin:3px 0;}' +
    '.ev-card-rating__stars{display:inline-flex;align-items:center;gap:0;color:#ed7e36;}' +
    '.ev-card-rating__stars svg{display:block;}' +
    '.ev-card-rating__count{font-weight:600;}' +
    '.ev-card-rating__fallback{font-weight:bold;color:#ed7e36;}';
  document.head.appendChild(style);

  function buildStars(r10) {
    var r5 = Math.round(r10) / 2;
    var full = Math.floor(r5), half = (r5 - full) >= 0.5 ? 1 : 0, empty = 5 - full - half;
    var h = '<span class="ev-card-rating__stars">';
    for (var i = 0; i < full; i++) h += FULL;
    for (var i = 0; i < half; i++) h += HALF;
    for (var i = 0; i < empty; i++) h += EMPTY;
    return h + '</span>';
  }

  function render(el, avg, count) {
    if (!count || !avg) {
      el.innerHTML = '<span class="ev-card-rating__fallback">ever ready</span>';
    } else {
      el.innerHTML = buildStars(avg) + '<span class="ev-card-rating__count">(' + count + ')</span>';
    }
  }

  function processAll(jsonData) {
    document.querySelectorAll('.ev-card-rating[data-sku]').forEach(function(el) {
      if (el.hasAttribute('data-avg')) {
        render(el, parseFloat(el.dataset.avg) || 0, parseInt(el.dataset.count) || 0);
      } else {
        var d = jsonData ? jsonData[el.dataset.sku] : null;
        render(el, d ? d.averageRating : 0, d ? d.numberReviews : 0);
      }
    });
  }

  function run() {
    if (!document.querySelector('.ev-card-rating[data-sku]')) return;
    window._evReviewsPromise = window._evReviewsPromise ||
      fetch(URL).then(function(r) { return r.json(); }).catch(function() { return {}; });
    window._evReviewsPromise.then(processAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
